const MuiIconButton = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&.MuiIconButton-variantDefault': {
        borderRadius: 0,
        '&:focus': {
          outline: `2px solid ${theme.palette.secondary.main}`
        }
      }
    }),
    // @ts-ignore TODO remove ignore once MUI is upgraded
    colorError: ({
      theme
    }) => ({
      color: theme.palette.grey[700]
    })
  }
};
export default MuiIconButton;